import React from 'react'
import PropTypes from 'prop-types'
import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth'
import { mapUserAttributes } from '../utils/user.js'
import { setEmptyUser, setUser } from '../state/actions'
import { useStateValue } from '../state'
import logger from '../logger'

const AuthGuard = ({ children }) => {
  const [{ user }, dispatch] = useStateValue()

  if (!user.isAuthenticated) {
    getUserSession()
      .then(userSession => {
        // User has signed in, update the Store with user attributes.
        dispatch(setUser(mapUserAttributes(userSession.userAttributes, userSession.session)))
      })
      .catch(err => {
        // User has not signed in. Set empty user to Store
        // so that Private Routes can reject this user.
        logger.error('Error caught', err)
        dispatch(setEmptyUser())
      })
  }
  return <>{children}</>
}

// After migrating to aws-amplify v6, we need to fetch required data from two different
// endpoint and combine them.
const getUserSession = async () => {
  const userAttributes = await fetchUserAttributes()
  const session = await fetchAuthSession()
  return { userAttributes, session }
}

AuthGuard.propTypes = {
  children: PropTypes.any
}

export default AuthGuard
